import { Instagram, MessageCircle, Sparkle } from "lucide-react";
import {
    ADDRESS,
    INSTAGRAM_HANDLE,
    INSTAGRAM_URL,
    NAV_LINKS,
    WHATSAPP_URL,
    scrollToSection,
} from "../constants/site";
import { useLang } from "../i18n/LangContext";
import { ShareButton } from "./ShareButton";

const Footer = () => {
    const { t } = useLang();
    return (
    <footer data-testid="footer" className="border-t border-burnt/15 wine-noir">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-12">
            <div className="grid gap-12 md:grid-cols-12">
                <div className="md:col-span-5">
                    <p className="flex items-baseline gap-2">
                        <span className="font-serif text-4xl tracking-tight text-cream">Yasmim</span>
                        <span className="flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.4em] text-burnt">
                            <Sparkle className="h-3 w-3" />
                            Nails
                        </span>
                    </p>
                    <p className="mt-5 max-w-sm text-sm leading-relaxed text-taupe">
                        {t.footer.tagline}
                    </p>
                </div>

                <div className="md:col-span-3">
                    <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">
                        {t.footer.nav}
                    </p>
                    <ul className="mt-6 space-y-3">
                        {NAV_LINKS.map((link, i) => (
                            <li key={link.id}>
                                <button
                                    data-testid={`footer-nav-link-${link.id}`}
                                    onClick={() => scrollToSection(link.id)}
                                    className="text-sm text-taupe transition-colors hover:text-gold"
                                >
                                    {t.nav.links[i]}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="md:col-span-4">
                    <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-gold">
                        {t.footer.contact}
                    </p>
                    <p className="mt-6 text-sm leading-relaxed text-taupe">{ADDRESS}</p>
                    <div className="mt-6 flex gap-3">
                        <a
                            data-testid="footer-whatsapp-link"
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noreferrer"
                            aria-label="WhatsApp"
                            className="flex h-11 w-11 items-center justify-center rounded-full border border-beige/25 text-cream transition-all duration-300 hover:border-gold hover:bg-gold hover:text-noir"
                        >
                            <MessageCircle className="h-4 w-4" />
                        </a>
                        <a
                            data-testid="footer-instagram-link"
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noreferrer"
                            aria-label={`Instagram ${INSTAGRAM_HANDLE}`}
                            className="flex h-11 w-11 items-center justify-center rounded-full border border-beige/25 text-cream transition-all duration-300 hover:border-gold hover:bg-gold hover:text-noir"
                        >
                            <Instagram className="h-4 w-4" />
                        </a>
                        <ShareButton
                            testId="footer-share-button"
                            className="flex h-11 w-11 items-center justify-center rounded-full border border-beige/25 text-cream transition-all duration-300 hover:border-gold hover:bg-gold hover:text-noir"
                        />
                    </div>
                </div>
            </div>

            <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-burnt/12 pt-8 sm:flex-row">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-taupe">
                    {t.footer.rights}
                </p>
                <p className="font-serif text-sm italic text-burnt">
                    {t.footer.quote}
                </p>
            </div>

            <div className="mt-8 flex items-center justify-center gap-3 border-t border-burnt/12 pt-8">
                <img
                    data-testid="ern-studio-logo"
                    src="/ern-studio-logo.png"
                    alt="ERN Studio"
                    loading="lazy"
                    className="h-8 w-8 rounded-full object-cover shadow-[0_2px_10px_rgba(107,78,50,0.25)]"
                />
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-taupe">
                    Desenvolvido por ERN Studio
                </span>
            </div>

        </div>
    </footer>
    );
};

export default Footer;
